import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { SEOHead } from '../components/SEOHead';

const sections = [
  {
    title: 'Website Use',
    body: 'The content on this website is provided for general business information about Hexalogix Automation, our services, and our technical capabilities. It does not by itself create a contractual commitment.'
  },
  {
    title: 'Quotations and Scope',
    body: 'Project pricing, schedules, delivery terms, and technical scope are confirmed only through formal quotations, proposals, purchase orders, or signed agreements.'
  },
  {
    title: 'Technical Content',
    body: 'We make reasonable efforts to keep service descriptions and technical information accurate, but specifications, capabilities, and availability may change as projects and supply conditions evolve.'
  },
  {
    title: 'Intellectual Property',
    body: 'Website text, branding, layouts, logos, and other original content belong to Hexalogix Automation unless otherwise noted. They may not be reused without permission.'
  },
  {
    title: 'Third-Party Links',
    body: 'This website may contain links to third-party services or external platforms. Hexalogix Automation is not responsible for the content or privacy practices of those external sites.'
  }
];

export const TermsPage = () => {
  return (
    <>
      <SEOHead
        title="Terms of Service | Hexalogix Automation"
        description="Terms of Service for Hexalogix Automation covering website use, quotations, technical content, and intellectual property."
        keywords="terms of service Hexalogix Automation, website terms, automation company terms"
      />

      <div className="min-h-screen bg-white">
        <section className="relative bg-[#0A0F1E] pt-16 md:pt-[106px] pb-16">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#0057B8]" />
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <nav className="flex items-center gap-2 text-sm text-gray-400 mb-6">
              <Link to="/" className="hover:text-white transition-colors">Home</Link>
              <ChevronRight className="w-3 h-3" />
              <span className="text-gray-300">Terms of Service</span>
            </nav>
            <h1 className="text-4xl sm:text-5xl font-black text-white mb-4">Terms of Service</h1>
            <p className="text-lg text-gray-300 max-w-3xl">
              These terms describe the general conditions for using this website and engaging with its published content.
            </p>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
            {sections.map((section) => (
              <div key={section.title} className="border-b border-gray-200 pb-8">
                <h2 className="text-2xl font-black text-[#0A0F1E] mb-4">{section.title}</h2>
                <p className="text-base text-gray-700 leading-relaxed">{section.body}</p>
              </div>
            ))}
            <div>
              <h2 className="text-2xl font-black text-[#0A0F1E] mb-4">Commercial Terms</h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Any project engagement, engineering scope, supply responsibility, warranty, payment terms, or delivery commitments will be governed by formal commercial documentation issued for that project.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
